import React from "react";
import { Helmet } from "react-helmet-async";

const TermsConditions = () => {
  return (
    <>
      {/* 🔥 SEO META TAGS */}
      <Helmet>
        <title>Terms & Conditions | LushDesire – Safe & Discreet Shopping</title>
        <meta
          name="description"
          content="Read LushDesire Terms & Conditions. Learn about eligibility, payments, product usage, and liability for safe and discreet online shopping in India."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://lushdesire.in/terms-conditions" />
      </Helmet>

      {/* ✅ PAGE CONTENT */}
      <main
        style={{
          backgroundColor: "#FFF5F5",
          minHeight: "100vh",
          paddingTop: "120px",
          paddingBottom: "60px",
        }}
      >
        <section
          style={{
            maxWidth: "900px",
            margin: "auto",
            padding: "0 20px",
            color: "#333",
            lineHeight: "1.7",
          }}
        >
          {/* 🔑 H1 – ONLY ONE */}
          <h1 style={{ marginBottom: "20px", color: "#A61325" }}>
            Terms & Conditions
          </h1>

          <p>
            Welcome to <strong>LushDesire</strong>. By accessing or using our
            website, you agree to comply with and be legally bound by the
            following Terms and Conditions. Please read them carefully before
            using our services.
          </p>

          {/* 🔑 H2 STRUCTURE FOR SEO */}
          <h2>Eligibility</h2>
          <p>
            You must be at least <strong>18 years of age</strong> to access this
            website or purchase any products from LushDesire. By using our
            website, you confirm that you meet this requirement.
          </p>

          <h2>Product Information</h2>
          <p>
            All products available on LushDesire are intended strictly for
            personal use. Product images are for illustrative purposes only and
            actual products may vary slightly in appearance or packaging.
          </p>

          <h2>Pricing & Payment</h2>
          <p>
            All prices listed on our website are subject to change without prior
            notice. We reserve the right to cancel or refuse any order at our
            discretion, including cases of incorrect pricing or stock
            unavailability.
          </p>

          <h2>Discreet Shipping & Privacy</h2>
          <p>
            We ensure 100% discreet packaging for all orders. Customer privacy
            is our priority, and personal information is handled securely in
            accordance with our Privacy Policy.
          </p>

          <h2>Limitation of Liability</h2>
          <p>
            LushDesire shall not be liable for any indirect, incidental, or
            consequential damages resulting from the use or misuse of our
            products or website.
          </p>

          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to update or modify these Terms & Conditions at
            any time without prior notice. Continued use of the website implies
            acceptance of the updated terms.
          </p>
        </section>
      </main>
    </>
  );
};

export default TermsConditions;
